module.exports = __webpack_public_path__ + "static/media/b16.a0438f3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/floorplans/thumbnails/b16.png
// module id = 322
// module chunks = 0